import React, { PureComponent, Fragment } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { consultaPendencias, clean } from '../actions/pendenciasActions'
import { DateTime } from 'luxon'
import { Card, CardText, CardBody, CardTitle, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { Loader } from 'modules/shared'
import { emissToDate } from 'helpers'
import PendenciasForm from './PendenciasForm'

const { SearchBar } = Search

const ExportCSV = (props) => {
    const handleClick = () => props.onExport()
    return <button style={{ borderRadius: 0 }} className="btn btn-info btn-sm" disabled={props.disabled} onClick={handleClick}>Exportar CSV</button>
}

class Pendencias extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            shouldShow: false,
            protocoloNumber: null
        }
    }

    submit(values) {
        return this.props.consultaPendencias(values)
    }

    toggleModal(cell) {
        this.setState({ shouldShow: !this.state.shouldShow, protocoloNumber: cell !== undefined ? cell : null })
    }

    mount() {

        const emissFormat = cell => emissToDate(cell)
        const protocoloLink = cell => {
            return cell !== '' ? <button onClick={() => this.toggleModal(cell)} style={{ fontSize: '.7rem' }} className="btn btn-sm btn-info">{cell}</button> : ''
        }

        let data
        if (this.props.pendenciasState.relatorio.exibition && this.props.pendenciasState.relatorio.exibition === 'pendencias') {
            data = this.props.pendenciasState.relatorio.dados.filter(d => !['Incluso no contas a pagar', 'Aguardando rotina de inclusão', 'Protocolado, porém já finalizado'].includes(d.status))
        } else {
            data = this.props.pendenciasState.relatorio.dados.filter(d => !['Aguardando rotina de inclusão'].includes(d.status))
        }

        const columns = [
            { dataField: 'index', text: 'index', sort: false, hidden: true, csvExport: false },
            { dataField: 'id_docsystem', text: 'ID Docsystem', sort: true, csvType: 'Number' },
            { dataField: 'tipo_nf', text: 'Tipo', sort: true },
            { dataField: 'status', text: 'Status', sort: true },
            { dataField: 'unidade', text: 'Empresa', sort: true },
            { dataField: 'documento', text: 'Docto', sort: true },
            { dataField: 'vencto', text: 'Vencto', sort: true },
            { dataField: 'protocolo', text: 'Protocolo', sort: true, formatter: protocoloLink },
            { dataField: 'validado_por', text: 'Validado por', hidden: true },
            { dataField: 'data', text: 'Validado em', hidden: true, formatter: emissFormat, csvFormatter: emissFormat },
        ]

        const expandRow = {
            renderer: row => <p>{ !!row.validado_por ? `Validado por ${row.validado_por} em ${emissToDate(row.data)}` : `` }</p>,
            showExpandColumn: true,
            onlyOneExpanding: true,
            expandByColumnOnly: true,
            expandColumnRenderer: ({ expanded }) => !expanded ? <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-plus fa-stack-1x fa-inverse"></i></span> : <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-minus fa-stack-1x fa-inverse"></i></span>,
            expandHeaderColumnRenderer: ({ isAnyExpands }) => !isAnyExpands ? <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-plus fa-stack-1x fa-inverse"></i></span> : <span style={{ cursor: 'pointer', fontSize: '.6rem'}} className="fa-stack"><i style={{ color: '#1983fc' }} className="fas fa-circle fa-stack-2x"></i><i className="fas fa-minus fa-stack-1x fa-inverse"></i></span>
        }

        const toolkitProps = { keyField: 'index', data, columns, search: { searchFormatted: true }, exportCSV: true }

        return (
            <div className="col pl-0 pr-4">
                <ToolkitProvider {...toolkitProps}>
                    {props => 
                        <Fragment>
                            <div className="row mb-3">
                                <div className="col col-sm-5">
                                    <SearchBar delay={ 250 } placeholder="Pesquisar..." className="form-control-sm" {...props.searchProps} />
                                </div>
                                <div className="col">
                                    <ExportCSV {...props.csvProps} disabled={props.baseProps.data.length ? false : true} />
                                    <button style={{ borderRadius: 0 }} onClick={() => this.props.clean()} className="btn btn-primary btn-sm">Nova consulta</button>
                                </div>
                            </div>
                            
                            <BootstrapTable
                                {...props.baseProps}
                                bootstrap4
                                hover
                                classes="table-sm table-font-size"
                                wrapperClasses="table-responsive"
                                pagination={paginationFactory({ sizePerPage: 50, sizePerPageList: [50, 100, 150, 200], showTotal: true, paginationTotalRenderer: (from, to, size) => (<span className="pl-3">Exibindo linhas {from} a {to} de {size}</span>) })}
                                noDataIndication={'Sem dados'}
                                expandRow={expandRow}
                            />
                        </Fragment>
                    }
                </ToolkitProvider>
            </div>
        )
    }

    render() {

        let { loading, relatorio } = this.props.pendenciasState

        if (loading)
            return <Loader />

        return (
            <div className="container-fluid">

                {relatorio === null &&
                    <div className="row mt-5">
                        <div className="col">
                            <PendenciasForm 
                                initialValues={{ 
                                    modo: 'id', 
                                    exibition: 'pendencias', 
                                    periodo: [new Date(), new Date()],
                                    periodo_filter: 'vencto' 
                                }} 
                                onSubmit={values => this.submit(values)} 
                            />
                        </div>
                    </div>}

                {relatorio && relatorio.modo === 'id' &&
                    <div className="row mt-5">
                        <div className="col col-sm-6 offset-sm-3">
                            <Card className="shadow-effect mt-5">
                                <CardBody style={{ fontSize: '.8rem' }}>
                                    <CardTitle>ID {relatorio.id_docsystem}</CardTitle>
                                    <CardText className="my-0"><strong className="pr-1">Status:</strong>{relatorio.status}</CardText>
                                    {!!relatorio.incluido_em && <CardText className="my-0"><strong className="pr-1">Incluso em:</strong>{relatorio.incluido_em}</CardText>}
                                    {!!relatorio.unidade && <CardText className="my-0"><strong className="pr-1">Empresa:</strong>{relatorio.unidade}</CardText>}
                                    {!!relatorio.documento && <CardText className="my-0"><strong className="pr-1">Documento:</strong>{relatorio.documento}</CardText>}
                                    {!!relatorio.vencto && <CardText className="my-0"><strong className="pr-1">Vencimento:</strong>{relatorio.vencto}</CardText>}
                                    {!!relatorio.protocolo && relatorio.status.match(/protocolado/i) && <CardText className="my-0"><strong className="pr-1">Protocolo:</strong>{<button onClick={() => this.toggleModal(relatorio.protocolo)} style={{ fontSize: '.7rem' }} className="btn btn-sm btn-info">{relatorio.protocolo}</button>}</CardText>}
                                    {!!relatorio.validado_por && <CardText className="my-0"><strong className="pr-1">Validado por:</strong>{relatorio.validado_por}</CardText>}
                                    {!!relatorio.validado_em && <CardText className="my-0"><strong className="pr-1">Validado em:</strong>{DateTime.fromFormat(relatorio.data.toString(), 'yyyyMMddHHmmss').toFormat('dd/MM/yyyy HH:mm:ss')}</CardText>}
                                    {!!relatorio.nota_fiscal_id && <CardText className="my-0"><strong className="pr-1">ID AS:</strong>{relatorio.nota_fiscal_id}</CardText>}
                                    <button onClick={() => this.props.clean()} className="btn btn-primary btn-sm mt-4">Nova consulta</button>
                                </CardBody>
                            </Card>
                        </div>
                    </div>}

                {relatorio && relatorio.modo === 'data' && <div className="row mt-5 mx-0">{this.mount()}</div>}

                <Modal size="lg" isOpen={this.state.shouldShow} toggle={() => this.toggleModal()}>
                    <ModalHeader toggle={() => this.toggleModal()}>Problemas detectados</ModalHeader>
                    <ModalBody>
                        {!!relatorio && !!this.state.protocoloNumber &&
                            <ul>
                                {relatorio.modo === 'data' && relatorio.dados.filter(d => d.protocolo && d.protocolo === this.state.protocoloNumber)[0].problemas.map((p, idx) => <li key={idx}>{p}</li> )}
                                {relatorio.modo === 'id' && relatorio.problemas.map((p, idx) => <li key={idx}>{p}</li> )}
                            </ul>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-secondary" onClick={() => this.toggleModal()}>Fechar</button>
                    </ModalFooter>
                </Modal>

            </div>
        )
    }
}

const mapStateToProps = store => ({ pendenciasState: store.pendenciasDocsystemState })
const mapDispatchToProos = dispatch => bindActionCreators({ consultaPendencias, clean }, dispatch)

export default connect(mapStateToProps, mapDispatchToProos)(Pendencias)